import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("ofm_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

// Sections per Leah Moschella brand PDF
export const CATEGORIES = [
    {
        key: "champagne-and-bagel-bites",
        label: "Champagne and Bagel Bites",
        short: "Champagne & Bagel Bites",
        blurb: "Growing up with less, finding myself with more, and the whiplash of moving between worlds.",
    },
    {
        key: "overachieving-for-me",
        label: "Overachieving for Me",
        short: "Overachieving for Me",
        blurb: "The mistakes I've made in pursuit of getting everything right.",
    },
    {
        key: "life-as-an-elective",
        label: "Life as an Elective",
        short: "Life as an Elective",
        blurb: "What happens when you actually close the laptop at 5 and invest in what makes you smile.",
    },
];

export const findCategory = (key) => CATEGORIES.find((c) => c.key === key);
